export type SocialIconType = "phone" | "mail" | "facebook" | "twitter" | "linkedin" | "youtube" | "instagram";

function SocialLinkIcon({ href, title, dataTracking, iconType, svgPathList, svgViewBox }:
  { href: string, title: string, dataTracking: string, iconType: SocialIconType, svgPathList: string[], svgViewBox: string }) {
  return (
    <a className="link link--social" target="_blank" rel="noreferrer" href={href} title={title} data-tracking={dataTracking}>
      <svg className="footer-icon">
        <title className={"title--" + iconType} lang="en">{iconType}</title>
        <use xlinkHref={"#icon-" + iconType}></use>
        <svg viewBox={svgViewBox} id={"icon-" + iconType}>
          {svgPathList.map(p => <path d={p}></path>)}
        </svg>
      </svg>
    </a>
  );
}
export default SocialLinkIcon;